import { Component, EventEmitter, Input, OnChanges, Output, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService, LocationService, LoaderService} from '@services';
import { AlertService, ModalService } from 'wacom';
@Component({
  selector: 'app-business-hours',
  templateUrl: './business-hours.component.html',
  styleUrls: ['./business-hours.component.scss']
})
export class BusinessHoursComponent implements OnInit, OnChanges {
	@Input('component') compon: boolean = false;
	@Input('location') location: any = {};
	@Input('submit') submit: boolean = false;
	@Output('onChange') Change = new EventEmitter();
	
	public profile:any = {};
	public close;
	public submitted:boolean;
	constructor(public us: UserService,
		public ls: LocationService,
		public alert: AlertService,
		public modal: ModalService,
		public router: Router,
		private loader: LoaderService) { }

	ngOnInit() {
		if (Object.keys(this.location).length !== 0) {
			this.profile = this.location;
		}
		this.onChange();
	}
	ngOnChanges(): void {
		if(this.compon) {
			this.submitted = this.submit;
		}
	}
	addHour(day) {
		if(this.profile.data.business_hours[day]?.length === 0) {
			this.profile.data.business_hours[day].push({from: '08:00', to: '20:00'});
		} else {
			const prevHour = this.profile.data.business_hours[day][this.profile.data.business_hours[day].length - 1];
			const endOfPrevHour = this.convertTimeToMinutes(prevHour.to);
			var startOfHour = (endOfPrevHour + 60) < (24 * 60) ? (endOfPrevHour + 60) : (23 * 60);
			var endOfHour = (startOfHour + 60) < (24 * 60) ? (startOfHour + 60) : (23 * 60 + 59);
			this.profile.data.business_hours[day].push({from: `${ String( Math.floor(startOfHour / 60) ).padStart(2, '0') }:${ String( startOfHour % 60 ).padStart(2, '0') }`, to: `${ String( Math.floor(endOfHour / 60) ).padStart(2, '0') }:${ String( endOfHour % 60 ).padStart(2, '0') }`});
		}
	}
	convertTimeToMinutes(time: string) {
		return Number(time.split(':')[0]) * 60 + Number(time.split(':')[1]);
	}
	onChange() {
		if(!this.profile.data) this.profile.data = {};
		if(!this.profile.data.business_hours) this.profile.data.business_hours = {};
		for (let i = 0; i < this.us.days_of_week.length; i++) {
			if(!this.profile.data.business_hours[this.us.days_of_week[i]]) this.profile.data.business_hours[this.us.days_of_week[i]] = []
		}
	}
	save() {
		this.loader.show({ 
			modal: true,
			transparent: true,
			preventClick: true
		}, document.querySelector('.modal-box'));

		this.submitted = true;
		for(let day of this.us.days_of_week) {
			for(const [index, hour] of this.profile.data.business_hours[day].entries()) {
				if(!hour.from || !hour.to) {
					this.loader.remove();
					return this.alert.error({
						text: "Please fill required fields",
					});
				}
				if( index > 0 && this.convertTimeToMinutes(hour.from) <= this.convertTimeToMinutes(this.profile.data.business_hours[day][index-1].to) || !!this.profile.data.business_hours[day]?.[index+1] && this.convertTimeToMinutes(hour.to) >= this.convertTimeToMinutes(this.profile.data.business_hours[day][index+1].from) || this.convertTimeToMinutes(hour.to) <= this.convertTimeToMinutes(hour.from)) {
					this.loader.remove();
					return this.alert.error({
						text: "Please resolve the time conflict",
					});
				}
			}
		}
		
		this.ls.create(this.profile, () => {
			this.loader.remove();
			this.close();
		});
	}
	back() {
		this.close();
		this.router.navigate([],{ queryParams: { modal: 'open' } });
		this.modal.show({component: 'locationprofile', profile: this.profile});
	}
}
